"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageGold = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var layout_1 = require("./shared/layout");
var title_1 = require("./shared/title");
var mini_k_chart_1 = require("./shared/mini_k_chart");
var title_quotetable_1 = require("./shared/title/title_quotetable");
var user_1 = __importDefault(require("../../modules/user"));
var thisuser = user_1.default.get();
/**
 * 黄金市场
 * @returns
 */
function PageGold() {
    (0, react_1.useEffect)(function () {
        window.scrollTo(0, 0);
    }, []);
    return (react_1.default.createElement("div", { className: "hjsc" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout3, { mt: 5 },
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "113.aum", height: 162, width: 324, border: false, link: false }, "\u9EC4\u91D1\u671F\u8D27")),
            react_1.default.createElement(layout_1.Layout3.Item, null, thisuser ?
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "101.GC00Y", height: 162, width: 324, border: false, link: false }, "\u56FD\u9645\u91D1\u4EF7")
                :
                    react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "113.aus", height: 162, width: 324, border: false, link: false }, "\u9EC4\u91D1\u671F\u8D27")),
            react_1.default.createElement(layout_1.Layout3.Item, null,
                react_1.default.createElement(BlockTitle, { mt: 0, txt: "金价K线", link: "" }),
                thisuser ?
                    react_1.default.createElement("div", { style: { margin: '10px 0' } },
                        react_1.default.createElement(mini_k_chart_1.MiniKChart, { width: 326, height: 162, quotecode: "101.GC00Y" }))
                    :
                        react_1.default.createElement("div", { style: { margin: '10px 0' } },
                            react_1.default.createElement(mini_k_chart_1.MiniKChart, { width: 326, height: 162, quotecode: "113.aum" })))),
        react_1.default.createElement(HJ_ChildTable, { mt: 10, tbkey: "HJSC_HOME1", fs: "i:111.JAGC,i:101.QI00Y,i:111.JPAC,i:101.HG00Y,i:111.JAUC,i:111.JPLC,i:102.PL00Y,i:101.QO00Y,i:101.MGC00Y,i:101.GC00Y,i:101.SI00Y,i:102.PA00Y", tit: "\u56FD\u9645\u8D35\u91D1\u5C5E\u671F\u8D27", link: "gridlist.html#nobalmetal_futures", orderdur: 1 }),
        react_1.default.createElement(HJ_ChildTable, { mt: 10, tbkey: "HJSC_HOME2", fs: "m:113+t:5", tit: "\u4E0A\u6D77\u9EC4\u91D1\u671F\u8D27", link: "gridlist.html#gold_sh_futures", orderdur: 1 }),
        react_1.default.createElement(HJ_ChildTable, { mt: 10, tbkey: "HJSC_HOME1", fs: "m:118", tit: "\u4E0A\u6D77\u9EC4\u91D1\u73B0\u8D27", link: "gridlist.html#gold_sh_spotgoods", orderdur: 1 }),
        react_1.default.createElement(HJ_ChildTable, { mt: 10, tbkey: "HJSC_HOME1", fs: "m:122,m:123", tit: "\u56FD\u9645\u8D35\u91D1\u5C5E\u73B0\u8D27", link: "gridlist.html#nobalmetal_spotgoods", orderdur: 1 })));
}
exports.PageGold = PageGold;
/**
 * 块级title
 * @param props
 * @returns
 */
function BlockTitle(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(title_1.Title1, { mt: props.mt },
            react_1.default.createElement(title_1.Title1.Main, null, props.txt),
            props.link && react_1.default.createElement(title_1.Title1.More, null,
                react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>")))));
}
function HJ_ChildTable(props) {
    return (react_1.default.createElement("div", { style: props.mt ? { marginTop: props.mt } : {} },
        react_1.default.createElement(title_quotetable_1.Title2QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>")), mt: props.mt,
            table_key: props.tbkey,
            fs: props.fs,
            count: 5,
            order: 'f3',
            orderdur: props.orderdur },
            react_1.default.createElement("a", { href: props.link, target: "_blank" }, props.tit))));
}
